import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=a1f8faf8&"
import script from "./EmailNotification.vue?vue&type=script&lang=js&"
export * from "./EmailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports